import { createContext } from "react";


export const MessageContext = createContext({forceHover: false});